import { INTERNAL_REDIRECT_KEYS, INTERNAL_REDIRECT_TYPE } from 'app-constants'
import { setDrawer } from 'slices/drawer'
import { setModal } from 'slices/modal'

export function getInternalRedirect(redirectKey) {
  return INTERNAL_REDIRECT_KEYS.find(({ KEY }) => KEY === redirectKey)
}

export function handleInternalRedirect(redirect, push = null) {
  if (!redirect) return

  switch (redirect.TYPE) {
    case INTERNAL_REDIRECT_TYPE.MODAL:
      return setModal({ key: redirect.TO })
    case INTERNAL_REDIRECT_TYPE.DRAWER:
      return setDrawer(redirect.TO)
    case INTERNAL_REDIRECT_TYPE.ROUTE:
      if (!push) return
      return () => push(redirect.TO)
    default:
      break
  }
}

export function isExternalUrl(url) {
  try {
    return !!new URL(url)
  } catch (_) {
    return false
  }
}

export function handleCtaRedirect(key, push) {
  const internalRedirect = getInternalRedirect(key)
  return handleInternalRedirect(internalRedirect, push)
}
